module.exports = __webpack_public_path__ + "static/media/img9.5f422015.jpg";